module.exports = __webpack_public_path__ + "img/jumbotron_under.f47d18e7.jpg";